module.exports = __webpack_public_path__ + "images/emoji/lipstick.9e30aa5e7edc864cbb2e.png";